import React, { useState, useMemo } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Autocomplete, {
    AutocompleteRenderInputParams,
} from '@material-ui/lab/Autocomplete';
import SignupTextField from './SignupTextField';
import { useAutoCompleteStyle } from './SimpleAutocompleteTextFieldComponent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store';

interface StateDropDownFieldProps {
    onChange: Function;
    validation: (text: string | undefined) => boolean;
    errorText?: string;
}

const useStyles = makeStyles(() => ({
    textFieldDropdown: {
        width: '100%',
    },
}));

const usaStates = [
    'AA',
    'AE',
    'AK',
    'AL',
    'AP',
    'AR',
    'AS',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'FM',
    'GA',
    'GU',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MH',
    'MI',
    'MN',
    'MO',
    'MP',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'PR',
    'PW',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UM',
    'UT',
    'VA',
    'VI',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
];

const StateDropDownField: React.FC<StateDropDownFieldProps> = ({
    validation,
    onChange,
    errorText,
}) => {
    const classes = useAutoCompleteStyle();
    const { textFieldDropdown } = useStyles();
    const defaultValue = useSelector(
        (state: AppState) => state.Signup.organizationState,
    );
    const [value, setValue] = useState<string>(defaultValue);
    const { t } = useTranslation();
    const copy = useMemo(
        () => ({
            placeholderState: t('signup.organizationName.placeholders.state'),
        }),
        [t],
    );

    const onChangeValue = (value: string) => {
        value = value.toUpperCase();
        setValue(value);
        onChange(value.length === 2 && usaStates.includes(value) ? value : '');
    };

    const onBlur = () => {
        if (value.length === 2 && usaStates.includes(value)) return;
        setValue('');
    };

    const handleChange = (e: unknown, value: string | null) => {
        if (!value) return;
        onChangeValue(value);
    };
    return (
        <Autocomplete
            classes={classes}
            fullWidth={true}
            clearOnEscape
            closeIcon={null}
            options={usaStates}
            inputValue={value}
            clearOnBlur={true}
            onChange={handleChange}
            onBlur={onBlur}
            renderInput={(params: AutocompleteRenderInputParams) => (
                <SignupTextField
                    className={textFieldDropdown}
                    {...params}
                    value={value}
                    isFocus={undefined}
                    type="text"
                    placeholder={copy.placeholderState}
                    onChange={onChangeValue}
                    validation={validation}
                    maxLength={2}
                    errorText={errorText}
                />
            )}
        />
    );
};

export default StateDropDownField;
